import * as React from 'react';
import { Provider } from 'react-redux';
import { IHttpApi } from '@cian/http-api/shared/http';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { IConfig } from '@cian/config/shared';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import { TReduxStore } from '../../types/redux';
import { ICustomContextParams } from '../../types/ICustomContextParams';
import { Promos } from '../Promos';
import { PurchaseContainer } from '../PurchaseContainer';
import { ContentWrapper } from '../../components/ContentWrapper';
import { ApplicationContext } from '../../utils/applicationContext';
import { Carousel } from '../Carousel';
import { Header } from '../Header';
import { Projects } from '../Projects';
import { Commercial } from '../Commercial';
import { About } from '../About';
import { Mortgage } from '../Mortgage';
import { Standard } from '../Standard';
import { AdfoxPixelContainer } from '../AdfoxPixel';
import { ClustersContainer } from '../Clusters';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
  httpApi: IHttpApi;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  customContext: ICustomContextParams;
}

export function Application(props: IApplicationProps) {
  const { logger, reduxStore, customContext, config, httpApi } = props;
  const context = React.useMemo(() => ({ config, logger, httpApi }), [config, httpApi, logger]);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={uaToDeviceType(customContext.userAgent)}>
          <Provider store={reduxStore}>
            <Carousel />
            <ContentWrapper>
              <Header />
              <Promos />
              <ClustersContainer />
              <Projects />
              <Mortgage />
              <PurchaseContainer />
              <Standard />
              <Commercial />
              <About />
              <AdfoxPixelContainer />
            </ContentWrapper>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
}
